import { observer } from 'mobx-react'
import { useContext } from 'react'
import { Header } from '@/components/Generic'
import { StoreContext } from '@store/Root.store'
import { EnpalEmbeddedVideo } from '@/components/EnpalEmbeddedVideo/EnpalEmbeddedVideo'
import { Illustration } from '@/components/Illustration/Illustration'

export const SuccessWithVideoEnpalPage = observer(() => {
  const store = useContext(StoreContext)
  const { SuccessWithVideoEnpalPage: successTrans, CongratulationsEnpalPage: errorTrans } =
    store.TranslationsState.translations

  const location = window.location.href
  const url = new URL(location)
  const isError = url.searchParams.get('error')
  const awaitingResumption = url.searchParams.get('awaitingResumption')

  if (isError) {
    return (
      <div className="page-container mobile-m-0">
        <Illustration type="identity-verification-failed" />
        <Header>{errorTrans.errorHeader}</Header>
        <p className="generic__paragraph-centered m-0-0-15">
          {awaitingResumption ? errorTrans.youWillReceiveAnEmail : errorTrans.errorContact}
        </p>
      </div>
    )
  }

  return (
    <div className="page-container mobile-m-0">
      <>
        <Illustration type="sign-document-success" />
        <Header className="no-margin">{successTrans.header}</Header>
        <p className="generic__paragraph-centered">{successTrans.subheader}</p>

        <div className="layout__margined m-0-0-15" />

        <p className="generic__paragraph">
          <strong>{successTrans.whatHappensNext.boldText}</strong>
          <br />
          {successTrans.whatHappensNext.paragraph}
        </p>

        <div className="enpal__step">
          <div className="npal__circle">1</div>
          <div className="enpal__info-text">{successTrans.line1}</div>
        </div>
        <div className="enpal__step">
          <div className="npal__circle">2</div>
          <div className="enpal__info-text">
            {successTrans.line2}{' '}
            <a
              className="generic__link"
              href="https://meine.kfw.de"
              target="_blank"
              rel="noreferrer"
              tabIndex={0}
            >
              {successTrans.line2Link}
            </a>
          </div>
        </div>
        <div className="enpal__step">
          <div className="npal__circle">3</div>
          <div className="enpal__info-text">{successTrans.line3}</div>
        </div>
        <div className="enpal__step">
          <div className="npal__circle">4</div>
          <div className="enpal__info-text">{successTrans.line4}</div>
        </div>

        <EnpalEmbeddedVideo />

        <div className="layout__margined m-0-0-15" />

        <p className="generic__paragraph m-0-0-15">
          <strong>{successTrans.footer.boldText}</strong>
          <br />
          {successTrans.footer.paragraph}{' '}
          <a
            className="generic__link"
            href="mailto:waermepumpe@enpal.de"
            target="_blank"
            rel="noreferrer"
            tabIndex={0}
          >
            {successTrans.footer.email}
          </a>
        </p>

        <div className="generic__spacer h-20" />
      </>
    </div>
  )
})
